import { Done } from '@mui/icons-material'
import { Box, Grid, Typography } from '@mui/material'
import SecDimButton from '../../../../shared/SecDimButton/SecDimButton'
import { createUrl } from '../../../../shared/UrlUtils/urlUtils'
import * as Styled from './TrialOfferStyles'

function TrialOffer({
	title,
	features,
	buttonText,
	isOpenDialog,
	onCloseButton,
}: TrialOfferProps) {
	const checkCircle = (
		<Box sx={{ mr: 1 }}>
			<Done color='primary' height='5px' width='5px' />
		</Box>
	)

	const redirectPlayerToSubscription = () => {
		sessionStorage.setItem(
			'redirectURI',
			`${window.location.toString().replace(window.location.search, '')}`,
		)
		window.location.href = createUrl(import.meta.env.VITE_SECDIM_ID_FRONTEND!, {
			path: ['subscription', 'trial'],
			params: { origin: 'learn' },
		})
	}

	return (
		<Styled.TrialDialog onClose={onCloseButton} open={isOpenDialog} maxWidth='sm'>
			<Styled.TrialWrapper sx={{ px: 2, py: 5, minHeight: 'inherit' }}>
				<Styled.AbsoluteClose onClick={onCloseButton} />
				<Box sx={{ display: 'flex', justifyContent: 'center', pb: 4 }}>
					<Typography align='center' variant='h5'>
						{title}
					</Typography>
				</Box>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						pl: 5,
						pr: 5,
						flexDirection: 'column',
					}}
				>
					{features.split(',').map((feature: string) => (
						<Grid key={feature}>
							<Box sx={{ display: 'flex', flexDirection: 'row' }}>
								{checkCircle}
								<Typography>{feature.trim()}</Typography>
							</Box>
						</Grid>
					))}
				</Box>
				<Styled.ButtonWrapper>
					<SecDimButton onClick={redirectPlayerToSubscription}>
						{buttonText}
					</SecDimButton>
				</Styled.ButtonWrapper>
			</Styled.TrialWrapper>
		</Styled.TrialDialog>
	)
}

export default TrialOffer
